import { useState } from "react";

import { GetSubscriptionsPopUp } from "../../components";

// Utility to decode HTML entities like &lt; &gt; etc
const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

const SkeletonCard = () => (
  <div className="p-3 lg:p-6 border border-gray-100 rounded-xl w-[350px] xl:w-[300px] h-full animate-pulse">
    {/* Desktop */}
    <div className="hidden lg:block">
      <div className="flex items-center gap-6">
        <div className="w-4/5 space-y-3">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-3 bg-gray-100 rounded w-full" />
        </div>
        <div className="flex flex-col w-1/5 space-y-2">
          <div className="h-6 bg-gray-200 rounded w-full" />
          <div className="h-3 bg-gray-100 rounded w-full" />
        </div>
      </div>
    </div>

    {/* Mobile */}
    <div className="block lg:hidden space-y-4">
      <div className="h-4 bg-gray-200 rounded w-2/3" />
      <div className="h-3 bg-gray-100 rounded w-5/6" />
    </div>

    <div className="pt-5">
      <div className="h-10 bg-gray-200 rounded-[34px] w-full" />
    </div>
  </div>
);

const SubscriptionsPlans = ({ data, loading = false }) => {
  const { plans } = data;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null); // Store selected plan

  const handleOpenPopup = (plan) => {
    setSelectedPlan(plan); // Set the selected plan
    setPopupOpen(true); // Open the popup
  };

  if (loading) {
    // Show 3 skeletons
    return (
      <>
        {[...Array(3)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </>
    );
  }

  console.log({plans});
  
  return (
    <>
      {plans.map((plan, index) => (
        <div className="p-3 lg:p-6 border border-gray-100 rounded-xl w-full lg:w-auto max-w-[225px] lg:max-w-[350px] xl:max-w-fit h-full lg:max-h-[190px]">
          <div className="hidden lg:block">
            <div className="flex items-center gap-4">
              <div className="w-4/5">
                <h3 className="text-base font-bold text-gray-800">
                  {plan.title}
                </h3>
                <div className="text-sm leading-[18px] font-normal text-gray-600" dangerouslySetInnerHTML={{ __html: plan.description }} />
              </div>
              <div className="flex flex-col w-1/5">
                <span className="text-2xl font-bold text-gold-500">
                  {plan.price}
                </span>
                <span className="text-xs text-gray-600 leading-[18px]">
                  {plan.frequency}
                </span>
              </div>
            </div>
          </div>
          <div className="block lg:hidden">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <div>
                  <h3 className="text-base font-bold text-gray-800">
                    {plan.title}
                  </h3>
                </div>
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-gold-500">
                    {plan.price}
                  </span>
                  <span className="text-xs text-gray-600 leading-[18px]">
                    {plan.frequency}
                  </span>
                </div>
              </div>
              <div className="text-sm leading-[18px] font-normal text-gray-600" dangerouslySetInnerHTML={{ __html: plan.description }} />
              </div>
          </div>
          <div className="pt-5">
            <a
              href={plan.link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <button
                onClick={() => handleOpenPopup(plan)}
                className={`${
                  plan.cancel
                    ? "border border-red-100 text-red-100 hover:bg-red-100 hover:text-gray-100"
                    : "bg-gold-300 text-gray-0 hover:bg-gold-200"
                } font-medium py-2 px-4 rounded-[34px] w-full`}
              >
                {plan.btnTitle || "Get Started"}
              </button>
            </a>
          </div>
        </div>
      ))}
      {/* Render the popup with dynamic data */}
      {selectedPlan && (
        <GetSubscriptionsPopUp
          isOpen={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          plan={selectedPlan}
        />
      )}
    </>
  );
};

export default SubscriptionsPlans;
